export const CATALOG_SLUG = 'diy-casino-party';
export const API_BASE_URL = (typeof window !== 'undefined' && window.__CASINO_API_BASE__) || '/api';
export const CART_STORAGE_KEY = 'casino_store_cart_token';
